<template>
  <div>
    <div v-for="(menu, index) in menuLista" :key="index">
      <q-tabs
        indicator-color="transparent"
        inline-label
        style=""
        vertical
        :active-color="
          tabSubmenu == menu.submenu.nomeVisualizacao && rotaAtual != 'home'
            ? 'brand-8'
            : ''
        "
        class="text-grey-7 col"
      >
        <div
          v-if="
            $store.state.autenticacao.perfil != undefined &&
            $store.state.autenticacao.perfil != null
          "
          class="row col-12"
        >
          <q-tab
            class="menu-item-principal"
            :name="menu.submenu.nomeVisualizacao"
            :class="[
              tab == menu.submenu.nomeVisualizacao && rotaAtual != 'home'
                ? 'menu-item-ativo'
                : 'menu-item-inativo',
              submenuAberto === menu.submenu.nomeVisualizacao
                ? 'menu-item-submenu-aberto'
                : '',
            ]"
            @click="directRoute(menu.submenu.nomeVisualizacao)"
            :icon="menu.submenu.icone"
            :label="menu.submenu.nomeVisualizacao"
          ></q-tab>
        </div>
        <q-menu
          v-if="menu.submenu.nomeVisualizacao != 'Simplificado'"
          class="menu-moderno"
          :offset="[10, 0]"
          anchor="center right"
          self="center left"
          @show="submenuAberto = menu.submenu.nomeVisualizacao"
          @hide="submenuAberto = null"
        >
          <div class="menu-header">
            <div class="menu-header-content">
              <div class="menu-icon-wrapper">
                <q-icon
                  class="menu-icon"
                  size="28px"
                  :name="menu.submenu.icone"
                />
              </div>
              <h6 class="menu-title">{{ menu.submenu.nomeVisualizacao }}</h6>
            </div>
          </div>

          <div class="menu-content">
            <div
              class="menu-item-card"
              v-for="(menuFilho, index) in menu?.submenu?.paginas"
              :key="index"
              v-show="
                ($store.state.autenticacao.usuarioLogado.permissoes.length !=
                  0 &&
                  $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                    buscarInformacoesPagina(menuFilho.nome)?.permission
                  ) != -1) ||
                buscarInformacoesPagina(menuFilho.nome)?.permission ===
                  undefined
              "
            >
              <router-link
                :to="{ name: menuFilho.nome }"
                class="menu-link"
                active-class="menu-link-active"
              >
                <q-item clickable v-close-popup class="menu-item-content">
                  <q-item-section class="menu-item-section">
                    <div class="menu-item-info">
                      <div class="menu-item-icon-wrapper">
                        <q-icon
                          size="18px"
                          class="menu-item-icon"
                          :name="menuFilho.icone"
                        />
                      </div>
                      <span class="menu-item-text">{{
                        menuFilho.descricao
                      }}</span>
                    </div>
                  </q-item-section>
                </q-item>
              </router-link>

              <div class="menu-item-actions">
                <q-btn
                  flat
                  dense
                  round
                  size="sm"
                  :icon="menuFilho.favorite ? 'star' : 'star_border'"
                  :color="menuFilho.favorite ? 'amber-6' : 'grey-5'"
                  class="favorite-btn"
                  @click="
                    (menuFilho.favorite = !menuFilho.favorite),
                      menuFilho.favorite == false
                        ? desfavoritar(menuFilho)
                        : favoritar(menuFilho)
                  "
                />
              </div>
            </div>
          </div>
        </q-menu>
        <q-menu
          v-if="mobile && menu.submenu.nomeVisualizacao != 'Simplificado'"
          class="menu-moderno mobile-menu"
          :offset="[10, 0]"
          @show="submenuAberto = menu.submenu.nomeVisualizacao"
          @hide="submenuAberto = null"
          anchor="center right"
          self="center left"
        >
          <div class="menu-header">
            <div class="menu-header-content">
              <div class="menu-icon-wrapper">
                <q-icon
                  class="menu-icon"
                  size="28px"
                  :name="menu.submenu.icone"
                />
              </div>
              <h6 class="menu-title">{{ menu.submenu.nomeVisualizacao }}</h6>
            </div>
          </div>

          <div class="menu-content">
            <div
              class="menu-item-card"
              v-for="(menuFilho, index) in menu?.submenu?.paginas"
              :key="index"
              v-show="
                ($store.state.autenticacao.usuarioLogado.permissoes.length !=
                  0 &&
                  $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                    buscarInformacoesPagina(menuFilho.nome)?.permission
                  ) != -1) ||
                buscarInformacoesPagina(menuFilho.nome)?.permission ===
                  undefined
              "
            >
              <router-link
                :to="{ name: menuFilho.nome }"
                class="menu-link"
                active-class="menu-link-active"
              >
                <q-item clickable v-close-popup class="menu-item-content">
                  <q-item-section class="menu-item-section">
                    <div class="menu-item-info">
                      <div class="menu-item-icon-wrapper">
                        <q-icon
                          size="18px"
                          class="menu-item-icon"
                          :name="menuFilho.icone"
                        />
                      </div>
                      <span class="menu-item-text">{{
                        menuFilho.descricao
                      }}</span>
                    </div>
                  </q-item-section>
                </q-item>
              </router-link>

              <div class="menu-item-actions">
                <q-btn
                  flat
                  dense
                  round
                  size="sm"
                  :icon="menuFilho.favorite ? 'star' : 'star_border'"
                  :color="menuFilho.favorite ? 'amber-6' : 'grey-5'"
                  class="favorite-btn"
                  @click="
                    (menuFilho.favorite = !menuFilho.favorite),
                      menuFilho.favorite == false
                        ? desfavoritar(menuFilho)
                        : favoritar(menuFilho)
                  "
                />
              </div>
            </div>
          </div>
        </q-menu>
      </q-tabs>
    </div>
  </div>
</template>

<script>
import { inject, ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import routes from "@/router/routes";
import { useRoute, useRouter } from "vue-router";
import { useQuasar } from "quasar";

export default {
  name: "BasicMenuList",
  props: ["menuList", "tabSubmenu"],
  emits: ["atualizar"],
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const quasar = useQuasar();

    const keycloak = inject("keycloak");
    const store = useStore();
    const innerTab = ref("");
    const subTab = ref("");
    const vazio = ref();
    const tab = ref(props.tabSubmenu);
    const submenuAberto = ref(null); // Controla qual submenu está aberto
    let mobile = ref(false);
    if (quasar.platform.is.mobile) {
      mobile = ref(true);
    }
    const modulosAtivos = ref("");
    const menuLista = ref(props.menuList);
    const rotaAtual = ref();

    let exit = async () => {
      store.dispatch("autenticacao/logout");
      keycloak.logout({ redirectUri: window.location.origin });
    };

    let action = async (routeName) => {
      if (routeName == "logout") {
        exit();
        return;
      }
      router.push({ name: routeName });
      subTab.value = routeName;
      localStorage.setItem("subTab", routeName);
    };

    watch(
      () => props.menuList,
      () => {
        if (props.menuList.length == 0) {
          innerTab.value = "";
        }
      }
    );

    const getSub = async () => {
      tab.value = props.tabSubmenu;
      subTab.value = route.name;
    };

    onMounted(getSub);

    const favoritar = (menuFilho) => {
      let favoritos = localStorage.getItem("favoritos");
      let existe = false;
      let array = JSON.parse(favoritos);
      if (array) {
        existe = array.some((rota) => rota.nome === menuFilho.nome);
        // existe = array.some((rota) => rota.name === menuFilho.meta.name);

        if (!existe) {
          array.push({
            icon: menuFilho.icone,
            label: menuFilho.descricao,
            labelPai: "",
            name: menuFilho.nome,
            permission: buscarInformacoesPagina(menuFilho.nome)?.permission,
          });
          localStorage.setItem("favoritos", JSON.stringify(array));
          localStorage.setItem("menu", JSON.stringify(props.menuList));
          emit("atualizar");
        }
        return;
      }
      let novoFavoritos = [];
      novoFavoritos.push({
        icon: menuFilho.icone,
        label: menuFilho.descricao,
        labelPai: "",
        name: menuFilho.nome,
        permission: buscarInformacoesPagina(menuFilho.nome),
      });

      localStorage.setItem("favoritos", JSON.stringify(novoFavoritos));
      localStorage.setItem("menu", JSON.stringify(props.menuList));
      emit("atualizar");
    };

    const desfavoritar = (menu) => {
      let array = JSON.parse(localStorage.getItem("favoritos"));
      array = array.filter((rota) => rota.name != menu.nome);
      localStorage.setItem("favoritos", JSON.stringify(array));
      localStorage.setItem("menu", JSON.stringify(props.menuList));
      emit("atualizar");
    };

    const getModules = async () => {
      try {
        let response = await store.dispatch("autenticacao/getModulosCliente", {
          type: "aba",
        });

        store.commit("autenticacao/INJETAR_MODULOS", {
          modulos: response.data.resultado.dados,
        });

        modulosAtivos.value = response.data.resultado.dados.map((e) => {
          return e.nome;
        });
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(getModules);

    const getVazios = async () => {
      // await props.menuList;
      // props.menuList.forEach((modulosPrincipais) => {
      //   modulosPrincipais.meta.show = false;
      //   if (modulosPrincipais.children != undefined) {
      //     const data = modulosPrincipais.children.map((filho) => {
      //       if (
      //         (filho.meta.permission == undefined && filho.meta.show == true) ||
      //         (store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
      //           filho.meta.permission
      //         ) != -1 &&
      //           filho.meta.show == true)
      //       ) {
      //         return filho;
      //       }
      //     });
      //     data.forEach((e) => {
      //       if (e != undefined) {
      //         modulosPrincipais.meta.show = true;
      //       }
      //     });
      //   }
      // });
    };

    const buscarInformacoesPagina = (pagina) => {
      let rotas = routes[0].children;
      let resultado = false;
      for (const rota of rotas) {
        if (resultado) {
          return;
        }
        if (rota?.children?.length > 0) {
          for (const menuFilho of rota?.children) {
            if (menuFilho.name === pagina) {
              resultado = true;
              return {
                permission: menuFilho?.meta?.permission,
                modulo: rota?.meta?.label,
              };
            }
          }
        }
      }
    };

    const adicionarNomeModuloPagina = () => {
      menuLista.value.forEach((submenu) => {
        if (submenu.submenu?.paginas.length > 0) {
          submenu.submenu?.paginas.forEach((pagina) => {
            pagina.modulo = buscarInformacoesPagina(pagina.nome)?.modulo;
          });
        }
      });

      /*menuLista.value.push({
        submenu: {
          id: "central-de-downloads",
          nome: "Central de Downloads\t",
          descricao: "Central de Downloads\t",
          nomeVisualizacao: "Central de Downloads",
          indice: 1,
          icone: "file_download",
          paginas: [
            {
              nome: "central-downloads-tabela",
              descricao: "Lista de Downloads",
              rota: "central-de-dawnload/central-downloads-tabela",
              icone: "settings",
              modulo: "Central de Downloads",
            },
          ],
        },
        perfil: "admin",
      });*/
    };

    watch(
      () => props.tabSubmenu,
      () => {
        getSub();
      }
    );

    watch(
      () => route.name,
      () => {
        rotaAtual.value = route.name;
      }
    );

    watch(
      () => props.menuList,
      () => {
        menuLista.value = props.menuList;
        adicionarNomeModuloPagina();
      }
    );
    const directRoute = async (name) => {
      if (name == "Simplificado") {
        router.push({ name: "spf-inicial" });
      }

      return;
    };

    onMounted(getVazios);

    onMounted(adicionarNomeModuloPagina);

    return {
      exit,
      action,
      innerTab,
      getSub,
      favoritar,
      subTab,
      tab,
      adicionarNomeModuloPagina,
      desfavoritar,
      directRoute,
      route,
      rotaAtual,
      mobile,
      getModules,
      modulosAtivos,
      vazio,
      getVazios,
      buscarInformacoesPagina,
      menuLista,
      submenuAberto,
    };
  },
};
</script>

<style scoped>
/* ==== MENU PRINCIPAL ==== */
.menu-item-principal {
  justify-content: flex-start !important;
  text-align: left !important;
  border-radius: 12px !important;
  margin: 4px 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 500 !important;
}

.menu-item-ativo {
  background: linear-gradient(135deg, #58afc1 0%, #4a9cb3 100%) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(88, 175, 193, 0.3) !important;
  transform: translateX(4px) !important;
}

.menu-item-inativo {
  color: #6b7280 !important;
  background: transparent !important;
}

.menu-item-inativo:hover {
  background: rgba(88, 175, 193, 0.1) !important;
  color: #58afc1 !important;
  transform: translateX(2px) !important;
}

/* ==== SUBMENU MODERNO ==== */
.menu-moderno {
  min-width: 420px !important;
  max-height: 85vh !important;
  border-radius: 16px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px) !important;
  overflow: hidden !important;
}

.menu-header {
  background: linear-gradient(135deg, #58afc1 0%, #4a9cb3 100%);
  color: white;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.menu-header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.menu-icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-icon {
  color: white;
}

.menu-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.menu-content {
  padding: 16px;
  max-height: 70vh;
  overflow-y: auto;
  background: white;
}

/* ==== ITEM DO MENU ==== */
.menu-item-card {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: white;
  transition: all 0.3s ease;
  overflow: hidden;
}

.menu-item-card:hover {
  border-color: #58afc1;
  box-shadow: 0 4px 16px rgba(88, 175, 193, 0.15);
  transform: translateY(-2px);
}

.menu-link {
  text-decoration: none;
  color: inherit;
  flex: 1;
}

.menu-link-active .menu-item-card {
  border-color: #58afc1;
  background: linear-gradient(
    135deg,
    rgba(88, 175, 193, 0.1) 0%,
    rgba(74, 156, 179, 0.05) 100%
  );
}

.menu-link-active .menu-item-text {
  color: #58afc1;
  font-weight: 600;
}

.menu-link-active .menu-item-icon {
  color: #58afc1;
}

.menu-item-content {
  padding: 16px !important;
  min-height: auto !important;
}

.menu-item-section {
  padding: 0 !important;
}

.menu-item-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.menu-item-icon-wrapper {
  background: #f3f4f6;
  border-radius: 8px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.menu-item-card:hover .menu-item-icon-wrapper {
  background: rgba(88, 175, 193, 0.1);
}

.menu-item-icon {
  color: #6b7280;
  transition: all 0.3s ease;
}

.menu-item-text {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  transition: all 0.3s ease;
  text-transform: capitalize;
}

.menu-item-actions {
  padding: 16px 12px;
  border-left: 1px solid #e5e7eb;
}

.favorite-btn {
  transition: all 0.3s ease;
}

.favorite-btn:hover {
  background: rgba(245, 158, 11, 0.1) !important;
  transform: scale(1.1);
}

/* ==== SCROLLBAR PERSONALIZADA ==== */
.menu-content::-webkit-scrollbar {
  width: 6px;
}

.menu-content::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 10px;
}

.menu-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.menu-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* ==== RESPONSIVO ==== */
@media (max-width: 600px) {
  .menu-moderno {
    min-width: 90vw !important;
    max-width: 90vw !important;
  }

  .mobile-menu {
    min-width: 85vw !important;
    max-width: 85vw !important;
  }

  .menu-header {
    padding: 16px 20px;
  }

  .menu-title {
    font-size: 16px;
  }

  .menu-content {
    padding: 12px;
  }

  .menu-item-content {
    padding: 12px !important;
  }
}

/* ==== ANIMAÇÕES ==== */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.menu-item-card {
  animation: slideIn 0.3s ease;
}

/* ==== COMPATIBILIDADE LEGACY ==== */
.q-menu {
  min-height: 100vh;
}

.active {
  color: #58afc1;
}

a {
  text-decoration: none;
  color: gray;
}

/* Estilo para menu com submenu aberto */
.menu-item-submenu-aberto {
  background: linear-gradient(
    135deg,
    rgba(88, 175, 193, 0.15) 0%,
    rgba(88, 175, 193, 0.25) 100%
  ) !important;
  color: #58afc1 !important;
  transform: translateX(2px);
  border-left: 3px solid #58afc1;
  box-shadow: 0 2px 8px rgba(88, 175, 193, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.menu-item-submenu-aberto::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    rgba(88, 175, 193, 0.1) 0%,
    transparent 100%
  );
  border-radius: 8px;
  pointer-events: none;
}
</style>
